module.exports = __webpack_public_path__ + "static/3-12b32866a026fdf333e5e1ef39f6eb56.jpeg";